export default "__VITE_ASSET__4r$ZO5hT__"